<template>
  <ModalContainer
    :is-show-modal="isShowModal"
    :nested-dialog="true"
    class="cookie-modal cookie-secondary-modal"
    @close="closeModal"
  >
    <template #header>
      <h2 class="cookie-secondary-modal__title">
        {{ $t("About the cookie policy") }}
      </h2>
      <IconButton icon="cross" @click="closeModal" />
    </template>
    <div class="cookie-secondary-modal__wrapper">
      <ContentRenderer
        v-if="cookieContent"
        :value="cookieContent"
        class="cookie-secondary-modal__text"
      />
      <BaseButton
        class="cookie-secondary-modal__confirm"
        @click="closeModalsAndSetCookie"
      >{{ $t("Confirm your cookie settings") }}</BaseButton
      >
    </div>
  </ModalContainer>
</template>

<script setup lang="ts">
import ModalContainer from "~/components/modals/ModalContainer.vue";
import IconButton from "~/components/button/IconButton.vue";
import BaseButton from "~/components/button/BaseButton.vue";

interface CookieSecondaryModalProps {
  isShowModal?: boolean;
  isShowCookiePrimaryModal: boolean;
  setCookie: () => void;
}

const props = withDefaults(defineProps<CookieSecondaryModalProps>(), {
  isShowModal: false,
});

const emit = defineEmits([
  "update:isShowModal",
  "update:isShowCookiePrimaryModal",
]);

const { locale } = useI18n();

const cookieContent = await queryCollection("content")
  .where("path", "LIKE", `/${locale.value}/cookie-modal/%`)
  .order("stem", "DESC")
  .first();

const closeModal = (): void => {
  emit("update:isShowModal", false);
};

const closeModalsAndSetCookie = (): void => {
  emit("update:isShowModal", false);
  emit("update:isShowCookiePrimaryModal", false);
  props.setCookie();
};
</script>
